import { For, Show } from 'solid-js';

import Notice from '../../../../../components/ui/Notice';

const BANK_CARD_MESSAGES = {
  en: [
    'Copy the card number',
    'Open your bank app',
    'Transfer charge to card number in one payment',
    'Expect cash receipts',
    'Please note that this amount does not include bank fees. The card number you send the payment is unique and only valid for one deposit.',
  ],
  ru: [
    'Скопируйте номер карты, указанный выше',
    'Откройте приложение вашего банка',
    'Одним платежом переведите на этот номер карты сумму для пополнения',
    'Ожидайте поступление денежных средств',
    'Обратите внимание, в эту сумму не входит комиссия банка. Номер карты, на которую вы отправляете платеж уникален и подходит только для одного депозита.',
  ],
};

function UtrTips(props: { currency: string; channel: string }) {
  const isTargetCurrencyAndChannel = props.currency.toUpperCase() === 'RUBFIAT' && props.channel === 'OctoPay-RUB';
  const messages = () => (setting.lang === 'ru' ? BANK_CARD_MESSAGES.ru : BANK_CARD_MESSAGES.en);

  return (
    <Show when={isTargetCurrencyAndChannel}>
      <Notice>
        <For each={messages()}>{(text) => <div>● {text}</div>}</For>
      </Notice>
    </Show>
  );
}

export default UtrTips;
